import { type Participant } from '@databases/presence';

import { getAiFieldStreamingParticipants } from './get-ai-field-streaming-participants';

interface GetRowCollaboratorColorOptions {
  participants: Participant[];
  recentCollaboratorColor: string | undefined;
  isAiFieldStreaming: boolean;
}

export const getEntryPresenceBorderColor = ({
  participants,
  recentCollaboratorColor,
  isAiFieldStreaming
}: GetRowCollaboratorColorOptions): string | undefined =>
  isAiFieldStreaming
    ? getAiFieldStreamingParticipants({
        participants,
        shouldExcludeAiAgent: true
      })[0]?.colorToken
    : recentCollaboratorColor;
